import { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { useSubscription } from '../../hooks/useSubscription';
import PaywallModal from './PaywallModal';

export default function TrialBanner() {
  const { isTrialing, trialDaysRemaining } = useSubscription();
  const [showPaywall, setShowPaywall] = useState(false);

  if (!isTrialing || trialDaysRemaining === null) {
    return null;
  }

  return (
    <>
      <button
        onClick={() => setShowPaywall(true)}
        className="w-full flex items-center justify-between px-4 py-2.5 bg-gradient-to-r from-accent to-orange-500 text-white hover:opacity-90 transition-opacity"
      >
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4" />
          <span className="text-sm font-medium">
            Trial: {trialDaysRemaining} day{trialDaysRemaining !== 1 ? 's' : ''} left
          </span>
        </div>
        <span className="text-sm font-medium">Subscribe</span>
      </button>

      <PaywallModal
        isOpen={showPaywall}
        onClose={() => setShowPaywall(false)}
      />
    </>
  );
}
